import {
  MenuItem,
  Box,
  FormControl,
  Select,
  Typography,
  Stack,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { ModifyVideoLibraryModal } from "../ModifyVideoLibraryModal";
import { inputCommonStyle } from "../../../../util/admin/cssCommonStyle";
import AddButton from "../../../../containers/super-admin/add-button";
import IwSwitch from "../../../app/IwSwitch";
import { useFormik } from "formik";
import { useUpdateOrg } from "../../../../tanstackQuery/queries/superAdmin/org";
import { useAtom } from "jotai";
import { SAdminBaseAtom } from "../../../../stores/jotai/super-admin/superAdminBase";
import { useKeycloak } from "@react-keycloak/web";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import OrgInfoSummary from "./OrgInfoSummary";
import { getOrgActionItems } from "./OrgAddItem";

const OrgInfoCard = ({ orgDetails, orgUserData, productDetails,  pendingUserList, invoicesData }) => {
  const { keycloak } = useKeycloak();
  const client = useQueryClient();
  const [sAdminBase,setSAdminBase]=useAtom(SAdminBaseAtom)
  const [enableVideoLibrary,setEnableVideoLibrary] = useState(orgDetails?.defaultVideoLibrary)
  const defaultProduct = productDetails?.find(
    (product) => product?.sku === orgDetails?.defaultProduct
  );
    const {
    mutateAsync: updateOrg,
    isPending,
    isSuccess,
  } = useUpdateOrg(
    { accessToken: keycloak?.token },
    { orgID:sAdminBase?.selectedOrg?.orgID},
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgUserDetails"] });
      },
    }
  );
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
        name: orgDetails?.name || "",
        defaultProduct: defaultProduct?.name || "",
        canUserPurchaseLicense: orgDetails?.canUserPurchaseLicense || 0,
        defaultVideoLibrary:  orgDetails?.defaultVideoLibrary || 0,
      },
      onSubmit: (values) => {
       handleSubmitOrgInfo(values);
      },
    });

    const handleSubmitOrgInfo = async (values) => {
      const updatedDefaultProduct = productDetails?.find(
        (product) => product?.name === values?.defaultProduct
      );
      
      const updatedOrgData = {
         ...values,
         name: values.name,
         defaultProduct: updatedDefaultProduct.sku,
         canUserPurchaseLicense:values.canUserPurchaseLicense,
         defaultVideoLibrary: values.defaultVideoLibrary,
      };
     try {
       await updateOrg(updatedOrgData);
       if (isSuccess) {
         toast.success("Org updated successfully!");
       }
     } catch (error) {
       formik.resetForm();
       toast.error(error?.response?.data?.message || "Failed to update Org.");
     }
   }
  return (
    <form onSubmit={formik.handleSubmit}>
      <Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{
            backgroundColor: "white",
            display: "flex",
            borderRadius: "4px",
            p: "10px 12px",
            my: 2,
          }}
        >
          <Stack direction="column" justifyContent="center" gap={2}>
            <Stack direction="row" gap={5} alignItems="center">
              <Box sx={{ flexBasis: "40%" }}>
                <Typography sx={{ fontWeight: "bold" }}>
                  {" "}
                  Organization Name
                </Typography>
              </Box>
              <Box sx={{ flexBasis: "60%" }}>
                <TextField
                  name="name"
                  variant="outlined"
                  size="small"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  fullWidth
                  sx={inputCommonStyle}
                />
              </Box>
            </Stack>
            <Stack direction="row" gap={5} alignItems="center">
              <Box sx={{ flexBasis: "40%" }}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Paywall Product
                </Typography>
              </Box>
              <Box sx={{ flexBasis: "60%" }}>
                <FormControl sx={inputCommonStyle}>
                  <Select
                    name="defaultProduct"
                    value={formik.values.defaultProduct}
                    onChange={formik.handleChange}
                    inputProps={{ "aria-label": "Without label" }}
                    id="select"
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200,
                          overflowY: "auto",
                        },
                      },
                    }}
                    sx={{ minWidth: "220px", maxWidth: "220px" }}
                  >
                    {productDetails?.map((product, index) => (
                      <MenuItem key={index} value={product?.name}>
                        {product?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
            <Stack direction="row" gap={5} alignItems="center">
              <Box sx={{ flexBasis: "40%" }}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Enable Paywall
                </Typography>
              </Box>
              <Box sx={{ flexBasis: "60%" }}>
                <IwSwitch
                  size="medium"
                  checked={formik.values.canUserPurchaseLicense === 1}
                  value={formik.values.canUserPurchaseLicense}
                  onChange={(event) => {
                    const newValue = event.target.checked ? 1 : 0;
                    formik.setFieldValue("canUserPurchaseLicense", newValue);
                  }}
                />
              </Box>
            </Stack>
          </Stack>

          <Stack direction="column" justifyContent="center" gap={2}>
            <Stack direction="row" gap={5} alignItems="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formik.values.defaultVideoLibrary === 1}
                    value={formik.values.defaultVideoLibrary}
                    onChange={(event) => {
                      const newValue = event.target.checked ? 1 : 0;
                      setEnableVideoLibrary(newValue)
                      formik.setFieldValue("defaultVideoLibrary", newValue);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Use Default Video Liabrary"
              />
            </Stack>
            <Stack direction="row" gap={5} alignItems="center">
              <ModifyVideoLibraryModal enableVideoLibrary={enableVideoLibrary}/>
            </Stack>
            <Stack direction="row" gap={5} alignItems="center">
              <Box sx={{ borderRadius: "50px" }}>
              <AddButton items={getOrgActionItems(setSAdminBase)} />
              </Box>
            </Stack>
          </Stack>
          <Stack direction="column" justifyContent="center" gap={2}>
            <Stack direction="row" gap={5} alignItems="center">
              <Button fullWidth variant="contained" disabled>
                View Invoices
              </Button>
            </Stack>
            <Stack direction="row" gap={5} alignItems="center">
              <Button fullWidth variant="contained" disabled>
                Delete
              </Button>
            </Stack>
            <Stack direction="row" gap={5} alignItems="center">
              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  backgroundColor: formik.dirty ? "#1976d2" : "#A5A5A5",
                }}
                disabled={!formik.dirty || isPending}
                endIcon={isPending ? <CircularProgress size={16} /> : null}
              >
                save
              </Button>
            </Stack>
          </Stack>

         <OrgInfoSummary 
           users = {orgUserData}  
           pendingUserList={pendingUserList}
           invoicesData={invoicesData}
          />
        </Stack>
      </Box>
    </form>
  );
};

export default OrgInfoCard;
